define('_views/Fan-modal',[
	'text!_templates/fan-modal.html'
],
function(
	modalTemplate
) {

	return Backbone.View.extend({

		template: _.template(modalTemplate),

		events: {
			// 'mousedown'					: 'preventDefault',
			'click'							: 'stopPropagation',
			'click .fm-cancel'				: 'close',
			'click [data-create-persona]'	: 'close',
			'click [data-become-a-fan]'		: 'ok',
			'click [data-login-to-fan]'		: 'loginToFan',
			'click'							: 'onclick',
			'keydown'						: 'bindKeyEvents',
			'change select'					: 'SelectSite',
			'click [data-change-current-user]': 'showSelectSite',
			'click [data-site-list]'		: 'triggerSelect'
		},

		className: 'fan-modal-overlay',

		initialize: function() {
			Backstage.Events.on('disable', this.remove, this);
			Backstage.Events.on('login:success', this.loginSuccess, this);
		},

		render: function(){

			this.$el.html(
				this.template({
					defaults : this.model.toJSON(),
					sites_list : Backstage.Collection.sitesAsEditorCollection.toJSON(),
				})
			);

			$(document.body).on('keyup.modal', _.bind(function(e){
				this.bindKeyEvents(e);
			}, this));

			parent.document.getElementsByTagName('html')[0].insertBefore(this.el, null);

			this.$el.removeClass('switch-sites');

			if (this.isMobile()) {
				this.$el.find('[data-fan-modal]').addClass('is_mobile');
			}

			return this;
		},

		/**
		 *	Test for iOS.
		 *  
		 *  @memberof Cargo.o.Helpers
		 *  @return {boolean}
		 *  @example Cargo.Helper.isIOS();
		 */
		isIOS : function() {
			if (navigator.userAgent.match(/i(Phone|Pod|Pad)/i)) {
				return true;	
			} else {
				return false;
			}
		},

		isMobile : function() {
			if(this.isIOS()) return true
			else {
				var check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
				return check;
			}
		},

		onclick: function(e){

			// check if click is on overlay
			if(e.target === this.el) {
				this.close(e);
			}

		},

		bindKeyEvents: function(e){

			if (e.which == 13) {
				this.ok(e);
			}
			else if (e.which == 27) {
				this.preventDefault(e);
				this.stopPropagation(e);
				this.close(e);
			}
		},

		stopPropagation: function(e) {
			e.stopImmediatePropagation();
		},

		preventDefault: function(e) {
			e.preventDefault();
		},

		close: function(e){

			if(e) this.preventDefault(e);

			$(document.body).off('keyup.modal');

			this.remove();

			if(this.login_iframe) {
				$(this.login_iframe).remove();
			}

			return false;
			
		},

		siteMenu: function() {

			return false;
		},

		ok: function(e) {
			Backstage.Events.trigger('toggle-fan');
			$(document.body).off('keyup.modal');
			this.remove();
			return false;
		},

		loginToFan: function(e) {
			var iframe = document.createElement('iframe');
			iframe.setAttribute('id', 'login_frame');
			iframe.src 			= '/login?rd=backstage';
			iframe.frameBorder 	= '0';
			
			// Attach this frame to the parent
			parent.document.getElementsByTagName('html')[0].insertBefore(iframe, this.el);

			this.login_iframe = parent.document.getElementById('login_frame');

			return false;	
		},

		/**
		 * This is called from an event fired from the child
		 * login iframe
		 */
		loginSuccess: function() {
			var _this = this;

			// First fetch the editor sites
			Backstage.Collection.sitesAsEditorCollection.fetch({
				success: function() {
					// Next fetch the updated defaults
					_this.model.fetch({
						success: function() {
							// Now close and re-render
							$(_this.login_iframe).remove();
							_this.render();
						}
					});
				}
			});

			

			return false;
		},

		/**
		 * So the actual site selection
		 */
		SelectSite: function(e) {
			var _this = this;
			// Update the cookie id in the default model

			$.post("/dispatch/auth/changeFanAuth", { 
				id : $(e.currentTarget).val(),
				fansite_url : this.model.get('site_url')
			}, function(data) { 
				if(data.error != "") {

					parent.window.Cargo.Modal.Alert({
						message: data.error,
						selector: 'html'
					});
					
				} else {
					
					_this.model.fetch({
						success: function() {
							_this.render();
						}
					});
						
				}
			}, "json");

			return false;
		},

		// manually open the select when clicking on parent
		triggerSelect: function(e) {
			if ($(e.target).is('[data-site-list]')) {

				var elem = $(e.target).find('select[name="site_list"]');
				
				if (document.createEvent) {
					var e = document.createEvent("MouseEvents");
					e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
					elem[0].dispatchEvent(e);
				} else if (element.fireEvent) {
					elem[0].fireEvent("onmousedown");
				}
			}
		},

		showSelectSite: function(e) {
			e.preventDefault()
			e.stopPropagation()
			$('.fm-logged-in-as, .fm-note', this.el).hide();
			$('[data-site-list]', this.el).removeClass('hidden');
			this.$el.addClass('switch-sites');
		},

	});

});

